import de from "./de.json"
import en from "./en.json"
import fr from "./fr.json"
import es from "./es.json"
import it from "./it.json"

export const translations = {
  de,
  en,
  fr,
  es,
  it,
}
